import React from "react";

import item1 from "../../assets/images/item1.png";
import item2 from "../../assets/images/item2.png";
import arrow from "../../assets/images/arrow.png";
import { getAllPopularCategories } from "../../helper/backend-methods";
import { useNavigate } from "react-router-dom";

export default function PopularCategories() {

  const navigate = useNavigate();

  const [popularCategories, setPopularCategories] = React.useState([]);

  const _getAllPopularCategories = async () => {
    try {
      const response = await getAllPopularCategories({store: 2, isPopular: true});
      setPopularCategories(response.data.Data);
    } catch (error) {
      console.error("Error fetching popular categories:", error);
    }
  };

  React.useEffect(() => {
    _getAllPopularCategories();
  }, []);


  return (
    <section id="popular-categories-section">
      <div className="wrapper">
        <div className="popular-categories-header">
          <h2>MOST POPULAR CATEGORIES</h2>
          <button type="button" onClick={() => navigate("/store/vendors")}>
            VIEW ALL VENDORS
            <img src={arrow} width={18} height={11} />
          </button>
        </div>

        <div className="popular-categories-grid">
          {popularCategories.map((item) => (
            <div key={item.CategoryId} className="popular-category-card">
              <img src={item.CategoryPicture?.Url || "static/media/mains-logo.6b089ddea9df137474bf.png" } alt={item.CategoryName} />

              <h3>{item.CategoryName}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
